<template>
	<!--Basic-box Outer-->
	<div class="basic-box__outer">
		<div class="basic-box__title text_center">Отпуск</div>

		<!--Basic-box Inner-->
		<div class="basic-box__inner">

			<!--Widget-->
			<div class="widget profile-clinic__widget flex" v-if="holidays.length"
					 v-for="range in holidays">

				<!--Date-->
				<div class="widget__inner widget__inner_time-table flex">
					<!--Date Item-->
					<div class="widget__time_item flex justify-center">
						<div class="widget__time">
							{{[range.begin, "X"] | moment('DD.MM')}} - {{[range.end, "X"] | moment('DD.MM')}}
							<i class="widget__icon widget__icon_close icon ion-android-close"
								 @click="removeSpecialTime(range._id)"></i>
						</div>
					</div>
					<!--Date Item End-->

				</div>
			</div>
			<!--Widget End-->

			<!--Buttons-->
			<div class="basic-box__btns basic-box__btns_placing">
				<button class="basic-box__btn basic-blue-btn full-width" @click="showPicker('Range', true)">
					Добавить отпуск
				</button>
			</div>
			<!--Buttons End-->

		</div>
		<!--Basic-box Inner End-->
	</div>
	<!--Basic-box Outer-->
</template>

<script>
	import Role from '@/common/Role';
	import moment from 'moment';

	export default {
		name: "VacationEditor",
		props: ['holidays'],
		computed: {
			workerId() {
				return this.$route.params.profile;
			},
			Role() {
				return new Role(this.$store.state.auth.user, this.$store.state.auth.worker, this.$store.state.auth.clinic)
			}
		},
		mounted() {
			this.$event.connect('saveSpecialRange', (date) => {
				this.saveSpecialRange(date)
			})
		},
		beforeDestroy() {
			this.$event.disconnect(['saveSpecialRange'])
		},
		methods: {
			updateSpecial() {
				this.$event.send('updateSpecial', {})
			},
			editTime(record) {
				if (!this.Role.isAdmin) {
					return false
				}

				record.pickerDate = moment(record.begin, 'X').format('YYYY-MM-DD');

				this.openModal(record)
			},

			saveSpecialRange(date) {
				let arr = date.split(' - ');

				this.$store.dispatch('special/create', {
					begin: moment(arr[0], 'YYYY-MM-DD').format('X'),
					end: moment(arr[1], 'YYYY-MM-DD').format('X'),
					worker_ids: [this.workerId],
					clinic_id: this.clinicId
				}).then(() => this.updateSpecial())
			},

			removeSpecialTime(id) {
				if (!this.Role.isAdmin) {
					return false
				}

				this.$store.dispatch('special/delete', id)
					.then(() => this.updateSpecial(this.workerId));
			},

			showPicker(type, show) {
				if (!this.Role.isAdmin) {
					return false
				}

				let action = (show) ? 'open' : 'close';
				this.$event.send(action + type + 'Picker', {})
			},

			openModal(record) {
				if (!this.Role.isAdmin) {
					return false
				}

				record.isSpecial = true;
				this.$event.send('openTimeModal', record)
			},

			closeModal() {
				this.$event.send('closeTimeModal', {});
			}
		}
	}
</script>



// WEBPACK FOOTER //
// VacationEditor.vue?452ef51d